module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ba-64e381d4fd68fad4609038c8d6f5838f.svg";